import React from 'react';
import './App.css';
import PancreaticCalculator from './components/PancreaticCalculator';

function App() {
  return (
    <div className="App">
      <div id="iframe-content-wrapper" data-iframe-size>
        <PancreaticCalculator />
      </div>
    </div>
  );
}

export default App;
